<template>
	<div id="app">
		<router-view></router-view>
		<!-- <Navbar></Navbar> -->
		<!-- <LandingPage></LandingPage> -->
		<!-- <LandingDashboard> </LandingDashboard> -->
	</div>
</template>

<script>
export default {
	components: {},
};
</script>

<style></style>
